import { purchaseStoreInitState } from '../utils/vuex-store-init/purchaseInit.util'

// localStorage 資料格式版本號
// 使用專案 version 作為資料版本，當版本升級時舊資料自動失效
const getStoreVersion = () => process.env.version || '1.0.0'

export const state = () => (
  purchaseStoreInitState()
)

export const getters = {
  getTotalPromotionDiscount (state) { // 取得優惠總折扣
    let totalCount = 0
    let promotion = null
    for (const id in state.promotion.selectedOptionByPromotionId) {
      promotion = state.promotion.selectedOptionByPromotionId[id]
      if (promotion && promotion.discount && promotion.discount.DiscountAmount) {
        totalCount += parseInt(promotion.totalCount) * parseInt(promotion.discount.DiscountAmount)
      }
    }
    return totalCount
  },
  uWashContactFlagPriceOptionList (state) {
    if (!this.service.IsNeedCheckContactPickUpFee || !state.contactPickupFeeList.length) return [] // 如未開放電聯，不加入品項
    return state.contactPickupFeeList.map(priceInfo => {
      priceInfo.PriceCount = 1
      return priceInfo
    })
  },
  uWashContactServicePriceTotal (state) {
    if (!this.service.IsNeedCheckContactPickUpFee || !this.uWashContactFlagPriceOptionList.length) return 0
    let priceTotal = 0
    this.uWashContactFlagPriceOptionList.forEach(priceInfo => {
      priceTotal += priceInfo.Price
    })
    return priceTotal
  },
  totalPromotionDiscount (state) { // 取得優惠總折扣
    let totalCount = 0
    for (const [, promotion] of Object.entries(state.promotion.selectedOptionByPromotionId)) {
      if (promotion.discount && promotion.discount.DiscountAmount) {
        totalCount += parseInt(promotion.totalCount) * parseInt(promotion.discount.DiscountAmount)
      }
    }
    return totalCount
  },
  getDateTime (state) {
    return state.selectedData.datetime
  },
  getOptionPriceGroup (state) { // 取得有金額options
    return state.optionPriceGroup
  },
  canGoNext (state) {
    return state.stepValidateList.every(fn => fn())
  },
  // 服務是否為社區模式
  isCommunity (state) {
    return state.service?.serviceAddressMode?.id === 2
  },
  selectedOptionPriceList (state) {
    return state.optionPriceGroup.filter(option => option.optionCount)
  },
  confirmBtnText (state) {
    if (state.service?.order_mode_id === 3) {
      return '確認諮詢'
    }
    return '確認訂購'
  },
  isSetOrderLoading: state => state.btn.isSetOrderLoading,
  canShowPromotion (state) {
    return state.promotion.PromotionDataList.length
  }
}

export const mutations = {
  resetState (state, keepService = true) {
    if (keepService) {
      const service = state.service
      Object.assign(state, {
        ...purchaseStoreInitState(),
        service
      })
    } else {
      Object.assign(state, purchaseStoreInitState())
    }
  },
  setServiceId (state, data) {
    state.serviceId = data
  },
  setServiceData (state, data) {
    state.service = data
  },
  setOptionPriceGroup (state, data) {
    state.optionPriceGroup = data
  },
  setPromotion (state, data) {
    state.promotion = data
  },
  setSelectedData (state, data) {
    state.selectedData = data
  },
  setIsShowCartDialog (state, data = true) {
    state.isShowCartDialog = data
  },
  setStep (state, data) {
    state.step = data
  },
  setContactPickupChecked (state, data) {
    state.contactPickupChecked = data
  },
  setContactPickupFeeList (state, data) {
    state.contactPickupFeeList = data
  },
  setDateTime (state, data) {
    if (!data) return
    state.selectedData.datetime = data
  },
  setRegion (state, data) {
    if (!data) return
    state.selectedData.region = data
  },
  addStepValidate (state, fn) {
    state.stepValidateList.push(fn)
  },
  setTermValidator (state, fn) {
    state.termValidator = fn
  },
  resetValidateList (state) {
    state.stepValidateList = []
    state.termValidator = null
  },
  updateSelectedData (state, { key, subKey, value }) {
    if (subKey) {
      // 支援多層巢狀結構
      const keys = subKey.split('.')
      let target = state.selectedData[key]

      // 遍歷到倒數第二層
      for (let i = 0; i < keys.length - 1; i++) {
        if (!target[keys[i]]) {
          target[keys[i]] = {}
        }
        target = target[keys[i]]
      }

      // 設定最後一層的值
      target[keys[keys.length - 1]] = value
    } else {
      // 更新頂層物件
      state.selectedData[key] = value
    }
  },
  setIsSetOrderLoading (state, value) {
    state.btn.isSetOrderLoading = value
  },
  setSkipLeaveCheck (state, data) {
    state.skipLeaveCheck = !!data
  },
  setSkipLeaveStoreState (state, data) {
    state.skipLeaveStoreState = !!data
  },
  setOrderResult (state, data) {
    state.orderResult = data
  },
  setStepObj (state, data) {
    state.stepObj = data
  },
  setTermChecked (state, data) {
    state.termChecked = data
  },
  setListenStepChange (state, data) {
    state.listenStepChange = data
  },
  setStartListenQueryStepChange (state, data) {
    state.startListenQueryStepChange = !!data
  },
  setOptionDefaultValue (state, optionGroup) {
    const optionValue = { ...state.selectedData.option }
    optionGroup.forEach(option => {
      if (option.category_option === 2) {
        // 單選
        optionValue[option.category_id] = null
      }
      if (option.category_option === 4) {
        // 複選
        optionValue[option.category_id] = []
      }
      if (option.category_option === 5) {
        // 問答
        optionValue[option.category_id] = ''
      }
    })
    state.selectedData.option = JSON.parse(JSON.stringify(optionValue))
  },
  restoreFromLocal (state) {
    let localData
    try {
      localData = JSON.parse(localStorage.getItem('purchaseStore'))
    } catch (e) {
      console.warn('[restoreFromLocal] localStorage 資料解析失敗', e)
      return
    }
    if (!localData) return
    // step 歸零，從第一步開始（由 auto jump 機制接管導航到目標步驟）
    localData.step = 0
    const initState = purchaseStoreInitState()
    for (const key in state) {
      if (localData[key] !== undefined) {
        if (key === 'selectedData') {
          // 以 initState 為基底 (結構為主)，將 localData 的值合併進去 (覆蓋)
          state[key] = _.merge({}, initState[key], localData[key])
        } else {
          state[key] = localData[key]
        }
      }
    }
    // 備份 datetime 供元件驗證
    if (state.selectedData?.datetime) {
      state.restoredDateTime = _.cloneDeep(state.selectedData.datetime)
    }
  },
  setConfirmPriceDetail (state, data) {
    state.confirmPriceDetail = data
  },
  setSelectedOptionData (state, data) {
    state.selectedData.option = data
  },
  setOrderPriceOptionList (state, data) {
    state.orderPriceOptionList = data
  },
  setOrderNonPriceOptionList (state, data) {
    state.orderNonPriceOptionList = data
  },
  setHasNonMatchedOptionFromOrder (state, data) {
    state.hasNonMatchedOptionFromOrder = data
  },
  setHasNonMatchedOptionFromLocalStorage (state, data) {
    state.hasNonMatchedOptionFromLocalStorage = data
  },
  setRestoredDateTime (state, data) {
    state.restoredDateTime = data
  }
}

export const actions = {
  async validateNextStep ({ state }) {
    const isFailed = result => (
      !result ||
      (result.status === 'rejected') ||
      (result.status === 'fufilled' && !result.value)
    )
    for (const fn of state.stepValidateList) {
      if (isFailed(await fn())) return false
    }
    // 步驟資料都通過才跳服務條款，避免先同意條款才發現必填未填寫
    if (state.termValidator && isFailed(await state.termValidator())) return false
    return true
  },
  /**
   * 等待 startListenQueryStepChange 被設為 true
   * 其他 component 可呼叫 this.$store.dispatch('purchaseStore/waitForStartListenQueryStepChange') 並 await 結果
   */
  waitForStartListenQueryStepChange ({ state }) {
    if (state.startListenQueryStepChange) return Promise.resolve(true)
    return new Promise((resolve) => {
      // this.watch 會回傳 unwatch function
      const unwatch = this.watch(
        (storeState) => storeState.purchaseStore.startListenQueryStepChange,
        (val) => {
          if (val) {
            unwatch()
            resolve(true)
          }
        }
      )
    })
  },
  nextStep ({ commit, state }, data) {
    console.log('nextStep trigger')
    commit('setStep', state.step + 1)
  },
  setServiceTimeDefaultMode ({ commit, state }, data) {
    const getServiceTimeDefaultMode = () => {
      const defaultMode = [
        { value: 1, label: '早上' },
        { value: 2, label: '下午' },
        { value: 4, label: '晚上' }
      ].filter(mode => state.service.reservation.indexOf(mode.value) > -1)
      if (defaultMode.length === 0) {
        commit('setDateTime', {
          ...state.selectedData.datetime,
          defaultTime: 7
        })
        return [{ value: 7, label: '皆可' }]
      } else {
        commit('setDateTime', {
          ...state.selectedData.datetime,
          defaultTime: defaultMode[0].value
        })
        return defaultMode.length > 1 ? [...defaultMode, { value: 7, label: '皆可' }] : defaultMode
      }
    }

    if ([1, 10].includes(state.service.serviceTimeType.id)) {
      commit('setDateTime', {
        ...state.selectedData.datetime,
        defaultModeList: getServiceTimeDefaultMode()
      })
    }
    if (state.service.serviceTimeType.id === 10) {
      commit('setDateTime', {
        ...state.selectedData.datetime,
        weekdayOrWeekendModeList: [
          {
            value: 1,
            label: '平日'
          },
          {
            value: 2,
            label: '假日'
          },
          {
            value: 3,
            label: '皆可'
          }
        ]
      })
    }
  },
  storeToLocal ({ state }) {
    const {
      serviceId,
      optionPriceGroup,
      step,
      selectedData,
      termChecked
    } = state

    // 過濾掉不需要保存的欄位
    const { recipient, region, payment, photoList, photoValidate, price, receipt, ...filteredSelectedData } = selectedData

    const saveState = {
      _version: getStoreVersion(),
      serviceId,
      optionPriceGroup,
      step,
      selectedData: filteredSelectedData,
      termChecked
    }
    localStorage.setItem('purchaseStore', JSON.stringify(saveState))
  },
  removeLocalData () {
    localStorage.removeItem('purchaseStore')
  },
  checkVersionAndClean () {
    let shouldClean = false
    try {
      const localData = JSON.parse(localStorage.getItem('purchaseStore'))
      const currentVersion = process.env.version || '1.0.0'
      if (localData && localData._version !== currentVersion) {
        console.warn(`[VersionCheck] 偵測到版本更新 (${localData._version} -> ${currentVersion})，正在清除舊有暫存資料...`)
        shouldClean = true
      }
    } catch (e) {
      console.warn('[VersionCheck] 資料解析失敗，執行預設清理', e)
      shouldClean = true
    }

    if (shouldClean) {
      try {
        localStorage.removeItem('purchaseStore')
        localStorage.removeItem('packageDeliveStore')
        sessionStorage.removeItem('processingServiceId')
        localStorage.removeItem('processingServiceId')
      } catch (e) {
        console.warn('[VersionCheck] 清除暫存資料時發生錯誤', e)
      }
    }
  },
  async fetchPromotionData ({ commit, dispatch }, serviceId) {
    const { data } = await this.$axios.get('/api/Promotion/GetPromotionDataByServiceId', { params: { service_id: serviceId } })
      .catch(error => {
        if (error?.response?.data?.ErrorMessage?.Code !== 400002) {
          dispatch('toast', {
            isOpen: true,
            text: '優惠資料取得失敗，請再試一次',
            type: 'error'
          }, { root: true })
        }
        return {
          data: {
            Data: {
              PromotionDataList: []
            }
          }
        }
      })
    const processedPromotionList = data.Data.PromotionDataList.map(promotion => ({
      ...promotion,
      maxDiscount: promotion.DetailList.reduce((maxAmount, detail) => {
        return detail.DiscountAmount > maxAmount ? detail.DiscountAmount : maxAmount
      }, 0)
    }))
    commit('setPromotion', {
      selectedOptionByPromotionId: {},
      selectingOptionByPromotionId: {},
      PromotionDataList: processedPromotionList
    })
  }
}
